import clsx from 'clsx';
import PropTypes from 'prop-types';

import Tag, {renderTagIfPresent} from 'components/Tag/index';
import logger from 'conf/Logger';

import './AlternateDrug.scss';


const propTypes = {
  context: PropTypes.oneOf(['guideline', 'guidelineAnnotation', 'label', 'labelAnnotation']).isRequired,
  showHelp: PropTypes.bool,
  className: PropTypes.string,
};

export default function AlternateDrugTag({context, showHelp = true, className}) {
  const props = {
    className: clsx('alternateDrugTag', className),
  };
  if (showHelp) {
    if (context === 'guideline' || context === 'guidelineAnnotation') {
      props.tooltipUrl = '/page/clinicalGuidelineLegend#clinical-guideline-annotation-tags';
    } else if (context === 'label' || context === 'labelAnnotation') {
      props.tooltipUrl = '/page/drugLabelLegend#drug-label-annotation-tags';
    } else if (context === 'pgxAssociation') {
      props.tooltipUrl = '/page/fdaPGxTableLegend';
    } else {
      logger.error(`context must be either "guidelineAnnotation" or "labelAnnotation", got "${context}"`);
      return <div className="text-danger">error - check console</div>;
    }
    props.tooltipText = 'Learn more about the Alternate Drug tag';
  }
  return (
    <Tag {...props}>Alternate Drug</Tag>
  );
}
AlternateDrugTag.propType = propTypes;


export function renderAlternateDrugTag({obj, showHelp, className}) {
  return renderTagIfPresent({
    tag: AlternateDrugTag,
    obj,
    dbProp: 'alternateDrugAvailable',
    indexProp: 'alt-drug',
    showHelp,
    className,
  });
}
